import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import { topLevelDomain } from './helpers'

export const userLanguages = () => {
  switch (topLevelDomain()) {
    case 'nl':
      return ['nl', 'en', 'fr']
    case 'be':
      return ['nl', 'fr', 'en']
    case 'lu':
      return ['fr', 'en', 'nl']
    case 'eu': // ccc
      return ['en', 'de', 'es', 'nl', 'fr', 'it']
    case 'es':
      return ['es', 'en']
    case 'it':
      return ['it', 'en']
    default:
      return ['en', 'de']
  }
}

export const i18n = i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: (languages: string[]) => {
        const currentLanguage = languages[0]
        return `/return-portal/i18n/${currentLanguage}.json`
      },
    },
    saveMissing: false,
    debug: false,
    supportedLngs: userLanguages(),
    detection: {
      order: ['navigator', 'querystring', 'cookie', 'localStorage', 'sessionStorage'],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })
  .then(() => {})
